
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const State = {
        currentView: 'chart',
        currentSortOption: 'alphabetical',
        currentSortOrder: 'asc',
        currentPage: 0,
        totalStocks: 0,
        stocksPerPage: 10,
        currentWatchlistData: null,
        currentUserId: null,
        currentWatchlistId: null,
        allWatchlists: [],

        pendingAdditions: [],
        pendingRemovals: [],

        addPendingAddition: function (ticker, data, watchlistId) {
            this.pendingAdditions = this.pendingAdditions.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
            this.pendingAdditions.push({
                ticker: ticker,
                watchlistId: watchlistId,
                timestamp: Date.now(),
                data: data || {}
            });
            this.pendingRemovals = this.pendingRemovals.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
        },

        addPendingRemoval: function (ticker, watchlistId) {
            this.pendingRemovals = this.pendingRemovals.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
            this.pendingRemovals.push({
                ticker: ticker,
                watchlistId: watchlistId,
                timestamp: Date.now()
            });
            this.pendingAdditions = this.pendingAdditions.filter(p => p.ticker !== ticker || p.watchlistId !== watchlistId);
        },

        cleanPending: function (currentStockData) {
            const now = Date.now();
            const EXPIRY = 300000;
            this.pendingRemovals = this.pendingRemovals.filter(p => (now - p.timestamp) < EXPIRY);
        },

        resetForNewWatchlist: function () {
            this.currentPage = 0;
            this.currentWatchlistData = null;
            this.pendingAdditions = [];
            this.pendingRemovals = [];
        },

        fullReset: function () {
            this.currentView = 'chart';
            this.currentSortOption = 'alphabetical';
            this.currentSortOrder = 'asc';
            this.currentPage = 0;
            this.totalStocks = 0;
            this.currentWatchlistData = null;
            this.currentUserId = null;
            this.currentWatchlistId = null;
            this.pendingAdditions = [];
            this.pendingRemovals = [];
        }
    };

    const DraftState = {
        deletedWatchlistIds: new Set(),
        selectedTickers: new Set(),
        hasUnsavedChanges: false,
        originalStateSnapshot: null,

        reset: function() {
            this.selectedTickers.clear();
            this.deletedWatchlistIds.clear();
            this.hasUnsavedChanges = false;
            this.originalStateSnapshot = null;
        },

        captureSnapshot: function(State) {
            if (!State || !State.currentWatchlistId) return;
            this.originalStateSnapshot = {
                watchlistId: State.currentWatchlistId,
                allWatchlists: JSON.parse(JSON.stringify(State.allWatchlists || [])),
                data: JSON.parse(JSON.stringify(State.currentWatchlistData || [])),
                deletedIds: new Set(this.deletedWatchlistIds)
            };
            this.hasUnsavedChanges = false;
        },

        restoreSnapshot: function(State) {
            if (!this.originalStateSnapshot) return;
            State.allWatchlists = JSON.parse(JSON.stringify(this.originalStateSnapshot.allWatchlists));
            State.currentWatchlistId = this.originalStateSnapshot.watchlistId;
            State.currentWatchlistData = JSON.parse(JSON.stringify(this.originalStateSnapshot.data));
            this.deletedWatchlistIds = new Set(this.originalStateSnapshot.deletedIds);
            this.hasUnsavedChanges = false;
            this.originalStateSnapshot = null;
        },

        addTickers: function(State, tickersWithData) {
            const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
            if (!currentWl) return;

            if (!currentWl.holdings) currentWl.holdings = {};
            if (!currentWl.tickers) currentWl.tickers = [];

            tickersWithData.forEach(item => {
                currentWl.holdings[item.ticker] = {
                    quantity: item.quantity,
                    price: item.price,
                    date_added: new Date().toISOString()
                };
                if (!currentWl.tickers.includes(item.ticker)) {
                    currentWl.tickers.push(item.ticker);
                }

                let existing = State.currentWatchlistData.find(s => s.ticker === item.ticker);
                if (!existing) {
                    existing = {
                        ticker: item.ticker,
                        price: item.price || 0,
                        todaysChangePerc: 0,
                        todaysChange: 0
                    };
                    State.currentWatchlistData.push(existing);
                }
            });

            this.hasUnsavedChanges = true;
        },

        removeTickers: function(State, tickers) {
            const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
            if (!currentWl) return;

            currentWl.tickers = currentWl.tickers.filter(t => !tickers.includes(t));
            if (currentWl.holdings) {
                tickers.forEach(t => delete currentWl.holdings[t]);
            }
            State.currentWatchlistData = State.currentWatchlistData.filter(s => !tickers.includes(s.ticker));

            this.hasUnsavedChanges = true;
        },

        updateHolding: function(State, data) {
            const currentWl = State.allWatchlists.find(w => w.id === State.currentWatchlistId);
            if (!currentWl || !data.ticker) return;

            if (!currentWl.holdings) currentWl.holdings = {};
            currentWl.holdings[data.ticker] = {
                ...currentWl.holdings[data.ticker],
                quantity: data.quantity,
                price: data.price,
                date_added: currentWl.holdings[data.ticker]?.date_added || new Date().toISOString()
            };

            this.hasUnsavedChanges = true;
        }
    };

    window.WatchlistApp.State = State;
    window.WatchlistApp.DraftState = DraftState;
})();